import Skills from './Skills.jsx';

export default Skills;
